import stackedBooks from '@images/home/stacked-books.png'
import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { HomeTile } from 'teacher-ui-client/components/home/tile'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { posthogEvent } from 'teacher-ui-client/modifiers/posthog'

interface Signature {
  Args: {
    reportingDashboardModels: unknown[]
  }
}

export class ReportsWriting extends Component<Signature> {
  get stackedBooksPng() {
    return stackedBooks
  }

  <template>
    <HomeTile @themeKey={{themeKey "writing"}} @title={{t "pages.home.panels.reports.title"}}>
      <div class="space-y-3 bg-white p-3">
        <div class="flex h-28 items-start">
          <img class="mr-6" src={{this.stackedBooksPng}} alt={{t "pages.home.panels.reports.booksImageAlt"}} />
          <p class="mb-3">{{t "pages.home.panels.reports.description"}}</p>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="reporting.ui-scope.writing-legends.dashboard-table"
            @appearance={{ButtonAppearance.regular}}
            @models={{@reportingDashboardModels}}
            {{posthogEvent "Reporting" product="writing-legends" page="dashboard-table"}}
          >
            {{t "pages.home.panels.reports.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
      </div>
    </HomeTile>
  </template>
}

export default ReportsWriting
